import { apiGet, apiPost, apiUpdate } from "../http";

export default {
  async getWHBrandsAPI() {
    return await apiGet(`api/WHBrands`);
  },
  async getWHSeasonsAPI() {
    return await apiGet(`api/WHSeasons`);
  },
  async createBrandAPI(data) {
    return await apiPost(`api/WHBrand`, data);
  },
  async createWHSeasonAPI(data) {
    return await apiPost(`api/WHSeason`, data);
  },
  async getWHCategories() {
    return await apiGet(`api/WHCategories`);
  },
  async createWHCategories(data) {
    return await apiPost(`api/WHCategories`, data);
  },
  async getWHDropDowns() {
    return await apiGet(`api/WHProduct/dropdowns`);
  },
  async updateWHBrandAPI(data) {
    return await apiUpdate(`api/WHBrand/${data.id}`, data);
  },
  async updateWHSeasonAPI(data) {
    return await apiUpdate(`api/WHSeason/${data.id}`, data);
  },
  async getWHGender() {
    return await apiGet(`api/WHGenders`);
  },
  async updateWHGenderAPI(data) {
    return await apiUpdate(`api/WHGender/${data.id}`, data);
  },
  async createWHGenderAPI(data) {
    return await apiPost(`api/WHGender`, data);
  },
  async updateWHCategory(data) {
    return await apiUpdate(`api/WHCategories/${data.id}`, data);
  },
  async getWHColorAPI() {
    return await apiGet(`api/WHColors`);
  },
  async updateWHColorAPI(data) {
    return await apiUpdate(`api/WHColor/${data.id}`, data);
  },
  async createWHColorAPI(data) {
    return await apiPost(`api/WHColor`, data);
  },

  async getWHLanguage() {
    return await apiGet(`api/WHLanguages`);
  },
  async updateWHLanguageAPI(data) {
    return await apiUpdate(`api/WHLanguage/${data.id}`, data);
  },
  async createWHLanguageAPI(data) {
    return await apiPost(`api/WHLanguage`, data);
  },
};
